// Set ol start as style
document.querySelectorAll('.editor-text ol[start]').forEach((olStart) => {
  olStart.setAttribute('style', `--start: ${olStart.getAttribute('start')}`);
});
